;(function ($) {
  var running = false,
    FORM = "",
    loading = false

  $('.staff__form button[type="submit"]').on("click touch", function (e) {
    e.preventDefault()

    running = false
    FORM = $(this).parents(".staff__form").serialize()

    $('.staff__form button[type="reset"]').removeClass("hidden")

    filter_staff()
  })

  $('.staff__form button[type="reset"]').on("click touch", function (e) {
    e.preventDefault()

    FORM = ""

    $(this).addClass("hidden")

    filter_staff()
  })

  function filter_staff() {
    var data = {
      action: "ctc_staff_filtering",
      form: FORM,
    }

    run_ajax(data, false, false)
  }

  function run_ajax(data, append = true, reset = false) {
    loading = true

    $(".staff__list").toggleClass("animating")

    $.post(ctc_ajax.ajaxurl, data, function (response) {
      if (response.length) {
        var res = jQuery.parseJSON(response)
        console.log(res)

        $("#staffDisplay").empty().append(res)

        $(".staff__list").toggleClass("animating")
      }
    })
  }
})(jQuery)
